export interface EnvironmentDeploy {
  release: string;
}

export const environment: EnvironmentDeploy = {
  release: "0.0.93#1370",
};
